/** These events will apply to the gang and only expect 1 event per side in order to act. */
export const GangStrategy = 'Gang';
/** These events will apply to each unit of a item (on a single-item gang) and
 * only update the Gang status when all units (including backs if applicable) have been processed. */
export const UnitStrategy = 'Unit';
/** These events will apply to each gang on a VGR2.0 layout/nest. */
export const NestStrategy = 'Nest';
export const customPatternStrategies = [GangStrategy, UnitStrategy, NestStrategy] as const;
export type CustomPatternStrategy = (typeof customPatternStrategies)[number];

export interface EventMapping {
    /** The event name from the press or adapter (.e.g., `printed` coming from an Intaglio adapter) */
    inputEvent: string;
    /** The event or status to publish (This code will check if it's a status and then determine if it needs to publish a status to Orders Service or the Shopfloor Event Tracking Service) */
    outputEventOrStatus: string;
    /** The event or status to publish when we dectect something as half-processed. */
    halfProcessedEventOrStatus?: string;
}

export interface CustomPattern {
    /** The unique ID of the pattern. */
    id: string;
    /** The name of the pattern. Unique in a tenant. */
    name: string;
    /** The tenant this pattern belongs to. Patterns are tenant-based so one plant can't affect another. */
    tenant: string;
    /** The order this should be applied in in case a filename can match to multiple patterns. (lower numbers occur first) */
    priority: number;
    /** Determines the behavior for matching events (e.g., is this event expecting to only see events at the gang level or each unit of a item on a single-item gang) */
    strategy: CustomPatternStrategy;
    /** The list of events/statuses mapped to the input event from the press/adapter */
    eventMapping: EventMapping[];
    /** Sets info for handling backside processing. This is different than hasBack in order to handle events for gangs that might have 2 sides, but maybe only have an event for one side (like raised-print only applied to the front) */
    backsideProcessing?: {
        /** The expression to determine if the respective gang and event should trigger backside-processing. */
        isEnabledExpression?: string;
    };
    /** The regex to match against. The regex will also need capture groups defined for some of the variables, such as gang, itn, unit, and side. */
    filenameRegex: string;
    /** Some example file names that should work for this regex */
    examples: string[];
}

export interface FileNamePattern {
    pattern: string;
    description: string;
    examples: string[];
    // list of fulfillers to exclude this filename pattern from
    excludedFulfillers?: string[];
}

export interface DoubleProcessedFileNamePattern extends FileNamePattern {
    doubleProcessingEventTypes: string[];
    backProcessingRequiredExpression: string;
}

export interface PatternResponse {
  message: string,
  customPatterns?: CustomPattern[],
  fileNamePatterns?: FileNamePattern[],
  doubleProcessedFileNamePatterns?: DoubleProcessedFileNamePattern[],
  halfPrintedFileNamePatterns?: FileNamePattern[],
  nestFileNamePatterns?: FileNamePattern[],
  internalTransitNbrFileNamePatterns?: FileNamePattern[],
}
